import { render } from "./TermManagement.vue?vue&type=template&id=6b3bb281&scoped=true"
import script from "./TermManagement.vue?vue&type=script&lang=js"
export * from "./TermManagement.vue?vue&type=script&lang=js"

import "./TermManagement.vue?vue&type=style&index=0&id=6b3bb281&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3bb281"]])

export default __exports__